import React from "react"
import Atelier from "../components/atelier"
import Layout from "../components/layout"
import SEO from "../components/seo"

const AtelierPage = () => {
  return (
    <Layout>
      <SEO title="Les ateliers" />
      <section className="section__content --fullHeight">
        <Atelier getOnlyFourItems={false} />
      </section>
    </Layout>
  )
}

export default AtelierPage
